import React, { ReactNode, useEffect, useState } from 'react';

interface SidebarLinkGroupProps {
  children: (
    handleClick: () => void,
    open: boolean,
    icon?: ReactNode,
    title?: string
  ) => ReactNode;
  activeCondition: boolean;
  icon?: ReactNode; // Optional icon prop
  title: string; // Required title prop for the group
  hidden?: boolean; // ẩn cả nhóm theo phân quyền (RBAC)
}

const SidebarLinkGroup = ({
  children,
  activeCondition,
  icon,
  title,
  hidden,
}: SidebarLinkGroupProps) => {
  const [open, setOpen] = useState<boolean>(activeCondition);

  // Chuyển sang một trang con của nhóm thì tự mở nhóm (nhóm đang chọn luôn hiện mục con).
  useEffect(() => {
    if (activeCondition) setOpen(true);
  }, [activeCondition]);

  const handleClick = () => {
    setOpen(!open);
  };

  if (hidden) return null;
  return <li>{children(handleClick, open, icon, title)}</li>;
};

export default SidebarLinkGroup;
